export default "__VITE_ASSET__e706a4f4__"